var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"access"},[_c('div',{staticClass:"access__pic"},[_c('img',{attrs:{"src":require("@/assets/img/access-denied.svg"),"alt":"Access denied"}})]),_c('h1',{staticClass:"access__title"},[_vm._v("Access denied")]),_c('span',{staticClass:"access__text"},[_vm._v("Sorry, you don't have correct rights for this page")])])
}]

export { render, staticRenderFns }